import React from 'react';
import { ModalHeader } from 'shards-react';

interface ModalEditHeaderProps {
  iconName: string;
  title: string;
}

const ModalEditHeader = ({ iconName, title }: ModalEditHeaderProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalHeader>
      <i className="material-icons mr-2">{iconName}</i>
      {title}
    </ModalHeader>
  );
};

export default ModalEditHeader;
